var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Constants } from './constants';
import { ClientService } from './client.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./client.service";
export class WhatsappBotGuard {
    constructor(router, clientService) {
        this.router = router;
        this.clientService = clientService;
        this.allowedClientIds = Constants.WhatsAppBotIds;
    }
    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //   const clientId = Number(route.paramMap.get('clientId'));
    //   if (this.allowedClientIds.includes(clientId)) {
    //     return true;
    //   }
    //   this.router.navigate([`client/${clientId}/dashboard`]);
    //   return false;
    // }
    canActivate(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            const clientId = Number(route.paramMap.get('clientId'));
            // allowed by config
            if (this.allowedClientIds.includes(clientId)) {
                return true;
            }
            try {
                const res = yield this.clientService.getPremiumBookings('whatsAppBot').toPromise();
                if (res && res.canAccess) {
                    return true;
                }
            }
            catch (err) {
                console.log(err);
            }
            // not allowed → redirect
            this.router.navigate([`client/${clientId}/dashboard`]);
            return false;
        });
    }
}
WhatsappBotGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WhatsappBotGuard_Factory() { return new WhatsappBotGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.ClientService)); }, token: WhatsappBotGuard, providedIn: "root" });
